<template>
  <!-- 广告管理 -->
  <div class="layout">
    <div class="menu">
      <Menu topIndex="dbWork"></Menu>
    </div>
    <div class="leftSide">
      <LeftSideBar current="dbWork" leftIndex="adManage"></LeftSideBar>
    </div>
    <div id="deptContentBox" class="base-content">
      <div>
        <el-button
          type="text"
          size="small"
          icon="el-icon-plus"
          @click="firstCreate()"
          >新增</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-delete"
          @click="preCheck('toDelete')"
          >删除</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-unlock"
           @click="preCheck('toUP')"
          >启用</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-lock"
          @click="preCheck('toDown')"
          >停用</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-document-add"
          @click="batchUpload()"
          >导入</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-download"
          @click="templateDownload"
          >下载资源导入模板</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-collection-tag"
          @click="getAdverTagList();adverTagManageDialog = true;"
          >标签管理</el-button
        >
      </div>
      <div id="searchBox">
            <el-form
              label-width="90px"
              ref="searchFileForm"
              :model="searchFileForm"
            >
              <el-form-item label="广告名称：">
                <el-input
                  v-model="searchFileForm.name"
                  placeholder="请输入广告名称"
                ></el-input>
              </el-form-item>
              <el-form-item label-width="0px">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-search"
                  @click="
                    currentPage = 1;
                    onSearch();
                  "
                  >查询</el-button
                >
              </el-form-item>
            </el-form>
      </div>
      <el-table
        :data="listTableData"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        style="width: 100%"
        class="maintable"
        border
        :header-cell-style="{ background: '#f8f8f8' }"
         @selection-change="handleTableSelectionChange"
      >
        <el-table-column
          type="selection"
          min-width="55"
          align="center"
        ></el-table-column>
        <el-table-column type="index" min-width="50" align="center">
        </el-table-column>
        <el-table-column
          prop="name"
          show-overflow-tooltip
          min-width="80"
          label="广告名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="tagNames"
          show-overflow-tooltip
          min-width="80"
          label="广告标签"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="endTime"
          show-overflow-tooltip
          min-width="80"
          label="截止时间"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="status"
          show-overflow-tooltip
          label="状态"
          min-width="70px"
          align="center"
        >
          <template slot-scope="scope">
            <span effect="dark" v-if="scope.row.status == 10">未启用</span>
            <span effect="dark" v-if="scope.row.status == 20">启用</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="link"
          show-overflow-tooltip
          label="链接"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="linkContent"
          show-overflow-tooltip
          min-width="80"
          label="链接文本"
          align="center"
        ></el-table-column>
        <el-table-column
            show-overflow-tooltip
            label="操作"
            align="center"
        >
            <template slot-scope="scope">
            <span
                class="right-add-button"
                style="display: block"
                @click="editAdver(scope.row)"
                >【编辑】</span
            >
            <span
                class="right-add-button"
                style="display: block"
                @click="toMaintainItem(scope.row.id)"
                >【条目维护】</span
            >
            </template>
        </el-table-column>
      </el-table>
      <!-- 列表分页 -->
      <div class="pagination-box">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize"
        >
        </el-pagination>
      </div>
      <!-- 批量导入弹窗 -->
      <el-dialog
        title="广告导入"
        :visible.sync="createUpdateDialog"
        width="600px"
      >

        <div class="uploadBox">
          <el-upload
            ref="batchUpload"
            action="/zyk/adver/importAdver"
            :headers="headers"
            :file-list="fileList"
            name="upfile"
            :before-upload="beforeBatchUploadData"
            :on-success="BUSuccess"
            :on-error="BUError"
            :auto-upload="false"
            accept=".zip"
          >
            <div slot="tip" class="el-upload__tip">
              必须为zip压缩文件,若资源超过4G，请联系管理员。
            </div>
            <el-button slot="trigger" size="small" type="primary"
              >选择文件</el-button
            >
            <el-button size="small" type="success" @click="submitbatchUpload"
              >上传并导入</el-button
            >
          </el-upload>
        </div>
      </el-dialog>

      <!-- 添加广告弹窗 -->
      <el-dialog title="新增广告" :visible.sync="createDialog" width="1000px">
        <el-form
          label-width="100px"
          :rules="addRules"
          ref="addForm"
          :model="addForm"
        >
          <el-form-item label="广告名称" style="width: 50%" prop="name">
            <el-input
              v-model="addForm.name"
              placeholder="请输入广告名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="广告标签" style="width: 50%">
            <el-select v-model="addTagIds" multiple placeholder="请选择广告标签">
                <el-option
                v-for="item in adverTagList"
                :key="item.id"
                :value="item.id"
                :label="item.name"
                ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="链接" style="width: 50%">
            <el-input
              v-model="addForm.link"
              placeholder="请输入链接"
            ></el-input>
          </el-form-item>
          <el-form-item label="链接文本">
            <el-input
              type="textarea"
              v-model="addForm.linkContent"
              placeholder="请输入链接文本"
            ></el-input>
          </el-form-item>
          <el-form-item label="截止时间：" prop="endTime">
            <el-date-picker
                v-model="addForm.endTime"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="缩略图" prop="logo">
            <div class="uploadBox">
              <el-upload
                class="avatar-uploader"
                ref="logoUpload"
                action="/zyk/resource/upload"
                :headers="headers"
                :show-file-list="false"
                name="upfile"
                :data="upLodeData"
                :before-upload="beforeAvatarUpload"
                :on-success="handleAvatarSuccess"
              >
                <div slot="tip" class="el-upload__tip">
                  只能上传jpg/png文件，且不超过500KB
                </div>
                <img v-if="logoImgUrl" :src="logoImgUrl" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="资源上传" prop="path">
            <div class="uploadBox">
              <el-upload
                ref="zyupload"
                action="/zyk/resource/upload"
                :headers="headers"
                :file-list="fileList"
                name="upfile"
                :before-upload="beforeUpload"
                :on-success="zySuccess"
                :auto-upload="false"
                :accept="acceptType"
                :data="upLodeData"
                :limit="1"
              >
                <el-button slot="trigger" size="small" type="primary"
                  >选择文件</el-button
                >
                <el-button size="small" type="success" @click="zySubmitUpload"
                  >开始上传</el-button
                >
              </el-upload>
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="onCreate('addForm')"
            >确 定</el-button
          >
          <el-button @click="createDialog = false">取 消</el-button>
        </span>
      </el-dialog>

      <!-- 编辑广告弹窗 -->
      <el-dialog title="编辑广告" :visible.sync="editDialog" width="1000px">
        <el-form
          label-width="100px"
          :rules="editRules"
          ref="editForm"
          :model="editForm"
        >
          <el-form-item label="广告名称" style="width: 50%" prop="name">
            <el-input
              v-model="editForm.name"
              placeholder="请输入广告名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="广告标签" style="width: 50%">
            <el-select v-model="addTagIds" multiple placeholder="请选择广告标签">
                <el-option
                v-for="item in adverTagList"
                :key="item.id"
                :value="item.id"
                :label="item.name"
                ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="链接" style="width: 50%">
            <el-input
              v-model="editForm.link"
              placeholder="请输入链接"
            ></el-input>
          </el-form-item>
          <el-form-item label="链接文本">
            <el-input
              type="textarea"
              v-model="editForm.linkContent"
              placeholder="请输入链接文本"
            ></el-input>
          </el-form-item>
           <el-form-item label="截止时间：" prop="endTime">
            <el-date-picker
                v-model="editForm.endTime"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="缩略图" prop="logo">
            <div class="uploadBox">
              <el-upload
                class="avatar-uploader"
                ref="logoUpload"
                action="/zyk/resource/upload"
                :headers="headers"
                :show-file-list="false"
                name="upfile"
                :data="upLodeData"
                :before-upload="beforeAvatarUpload"
                :on-success="handleAvatarSuccess"
              >
                <div slot="tip" class="el-upload__tip">
                  只能上传jpg/png文件，且不超过500KB
                </div>
                <img v-if="logoImgUrl" :src="logoImgUrl" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="资源上传" prop="path">
            <div class="uploadBox">
              <el-upload
                ref="zyupload"
                action="/zyk/resource/upload"
                :headers="headers"
                :file-list="fileList"
                name="upfile"
                :before-upload="beforeUpload"
                :on-success="zySuccess"
                :auto-upload="false"
                :accept="acceptType"
                :limit="1"
              >
                <el-button slot="trigger" size="small" type="primary"
                  >选择文件</el-button
                >
                <el-button size="small" type="success" @click="zySubmitUpload"
                  >开始上传</el-button
                >
              </el-upload>
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="onEdit('editForm')"
            >确 定</el-button
          >
          <el-button @click="editDialog = false">取 消</el-button>
        </span>
      </el-dialog>

      <!-- 删除确认弹窗 -->
      <el-dialog
        title="删除广告"
        :visible.sync="deletePreDialog"
        width="600px"
        >
        <div>确定删除该广告</div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="deleteEntry">确 定</el-button>
            <el-button @click="deletePreDialog = false">取 消</el-button>
        </span>
      </el-dialog>

      <!-- 标签管理弹窗 -->
       <el-dialog
        title="标签管理"
        :visible.sync="adverTagManageDialog"
        width="600px"
       >
        <div>
            <el-button
            type="text"
            size="small"
            icon="el-icon-plus"
            @click="addAdverTagDialog = true;addAdverTagForm={};newAdverTagTitle='新增广告标签'"
            >新增</el-button
            >
        </div>
        <el-popover
            v-for="item in adverTagList"
            :key="item.id"
            placement="bottom"
            width="160"
            :title="item.name"
            class="adverTagItem"
            >
            <p>{{item.remark }}</p>
            <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="deleteTagPreDialog = true;deleteAdverTagId = item.id">删除</el-button>
                <el-button type="primary" size="mini" @click="editAdverTag(item)">编辑</el-button>
            </div>
            <el-button slot="reference">{{item.name}}</el-button>
        </el-popover>
       </el-dialog>       
       
       <!-- 新增广告标签弹窗 -->
       <el-dialog
        :title="newAdverTagTitle"
        :visible.sync="addAdverTagDialog"
        width="800px"
       >
        <el-form
        v-if="createFlag == 'add'"
          label-width="100px"
          :rules="addAdverTagRules"
          ref="addForm"
          :model="addAdverTagForm"
        >
          <el-form-item label="标签名称" style="width: 50%" prop="name">
            <el-input
              v-model="addAdverTagForm.name"
              placeholder="请输入标签名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="标签备注">
            <el-input
              type="textarea"
              v-model="addAdverTagForm.remark"
              placeholder="请输入标签备注"
            ></el-input>
          </el-form-item>
        </el-form>
        <el-form
        v-if="createFlag == 'edit'"
          label-width="100px"
          :rules="editAdverTagRules"
          ref="addForm"
          :model="editAdverTagForm"
        >
          <el-form-item label="标签名称" style="width: 50%" prop="name">
            <el-input
              v-model="editAdverTagForm.name"
              placeholder="请输入标签名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="标签备注">
            <el-input
              type="textarea"
              v-model="editAdverTagForm.remark"
              placeholder="请输入标签备注"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="createAdverTag()"
            >确 定</el-button
          >
          <el-button @click="addAdverTagDialog = false">取 消</el-button>
        </span>
       </el-dialog>

       <!-- 广告标签删除确认弹窗 -->
      <el-dialog
        title="删除广告标签"
        :visible.sync="deleteTagPreDialog"
        width="600px"
        >
        <div>确定删除该标签</div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="deleteTagEntry">确 定</el-button>
            <el-button @click="deleteTagPreDialog = false">取 消</el-button>
        </span>
      </el-dialog>

      <!-- 维护条目 -->
       <el-dialog
        title="条目维护"
        :visible.sync="maintainItemDialog"
        width="1000px"
       >
       <!-- 按钮 -->
        <div>
            <el-button
            type="text"
            size="small"
            icon="el-icon-plus"
            @click="getAllItem();getSourceList();addItemToAdDialog = true;allItemSearchForm = {}"
            >新增</el-button>
            <el-button
            type="text"
            size="small"
            icon="el-icon-edit"
            @click="editPre()"
            >编辑</el-button>
            <el-button
            type="text"
            size="small"
            icon="el-icon-delete"
            @click="deleteItemPreDialog = true"
            >删除</el-button>
        </div>
        <!-- 搜索 -->
          <div id="itemSearchBox" style="margin-top: 10px;">
              <el-form
                label-width="90px"
                ref="itemSearchForm"
                :model="itemSearchForm"
                class="clearfix"
                style="padding:0"
              >
                <el-form-item label="资源名称">
                  <el-input
                    v-model="itemSearchForm.name"
                    placeholder="请输入资源名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label="展示位置">
                 <el-select v-model="itemSearchForm.type" clearable>
                    <el-option value="10" label="顶部"> </el-option>
                    <el-option value="20" label="侧边"> </el-option
                    ><el-option value="30" label="底部"> </el-option>
                </el-select>
                </el-form-item>
                <el-form-item label-width="0px">
                  <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-search"
                    style="margin-left: 10px;"
                    @click="
                      itemCurrentPage = 1;
                      itemOnSearch();
                    "
                    >查询</el-button
                  >
                </el-form-item>
              </el-form>
          </div>
        <el-table
            :data="adverItemListData"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            style="width: 100%"
            class="maintable"
            border
            :header-cell-style="{ background: '#f8f8f8' }"
            @selection-change="adverItemHandleTableSelectionChange"
        >
            <el-table-column
            type="selection"
            min-width="55"
            align="center"
            ></el-table-column>
            <el-table-column type="index" min-width="50" align="center">
            </el-table-column>
           <el-table-column
              prop="name"
              show-overflow-tooltip
              min-width="80"
              label="资源标题"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="subBranch"
              label="分支"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="endTime"
              label="结束时间"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="type"
              show-overflow-tooltip
              label="展示位置"
              width="80px"
              align="center"
            >
              <template slot-scope="scope">
                <span effect="dark" v-if="scope.row.type == 10">顶部</span>
                <span effect="dark" v-if="scope.row.type == 20">侧边</span>
                <span effect="dark" v-if="scope.row.type == 30">底部</span>
              </template>
            </el-table-column>
        </el-table>
         <!-- 列表分页 -->
        <div class="pagination-box">
            <el-pagination
            @size-change="itemHandleSizeChange"
            @current-change="itemHandleCurrentChange"
            :current-page="itemCurrentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="itemPageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="itemTotalSize"
            >
            </el-pagination>
        </div>
        <span slot="footer" class="dialog-footer">
            <!-- <el-button type="primary" @click="commitMaintainItem()">确 定</el-button> -->
            <el-button @click="maintainItemDialog = false">取 消</el-button>
        </span>
       </el-dialog>

       <!-- 给广告新增条目弹窗 -->
        <el-dialog
        title="新增条目"
        :visible.sync="addItemToAdDialog"
        width="800px"
       >
       <p style="margin-bottom: 20px;">
            <span>结束时间：</span>
            <el-date-picker
                v-model="maintainItemFrom.endTime"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
            >
            </el-date-picker>
        </p>
        <p style="margin-bottom: 20px;">
            <span>展示位置：</span>
            <el-select v-model="maintainItemFrom.type" clearable>
                <el-option value="10" label="顶部"> </el-option>
                <el-option value="20" label="侧边"> </el-option
                ><el-option value="30" label="底部"> </el-option>
            </el-select>
        </p>
        <div style="border: 1px solid rgba(0, 0, 0, 0.1);padding: 10px;border-radius: 10px;">
          <div id="addItemToAdSearchBox">
              <el-form
                label-width="90px"
                ref="allItemSearchForm"
                :model="allItemSearchForm"
                class="clearfix"
                style="padding:0"
              >
                <el-form-item label="资源名称">
                  <el-input
                    v-model="allItemSearchForm.name"
                    placeholder="请输入资源名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label="来源">
                  <el-select
                    placeholder="请选择来源"
                    v-model="allItemSearchForm.sourceId"
                    clearable
                  >
                    <el-option
                      v-for="item in sourceList"
                      :key="item.id"
                      :value="item.id"
                      :label="item.name"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="资源状态">
                  <el-select v-model="allItemSearchForm.status" clearable>
                    <el-option value="10" label="下架"> </el-option>
                    <el-option value="20" label="上架"> </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="删除状态">
                  <el-select v-model="allItemSearchForm.isRemove" clearable>
                    <el-option value="10" label="未删除"> </el-option>
                    <el-option value="20" label="已删除"> </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="是否展示广告" label-width="100px">
                  <el-select v-model="allItemSearchForm.isAdver" clearable>
                    <el-option value="10" label="否"> </el-option>
                    <el-option value="20" label="是"> </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label-width="0px">
                  <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-search"
                    style="margin-left: 10px;"
                    @click="
                      allItemCurrentPage = 1;
                      allItemOnSearch();
                    "
                    >查询</el-button
                  >
                </el-form-item>
              </el-form>
          </div>
          <el-table
              :data="allItemData"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
              style="width: 100%"
              class="maintable"
              border
              :header-cell-style="{ background: '#f8f8f8' }"
              @selection-change="allItemHandleTableSelectionChange"
          >
              <el-table-column
              type="selection"
              min-width="55"
              align="center"
              ></el-table-column>
            <el-table-column
                    prop="name"
                    show-overflow-tooltip
                    min-width="80"
                    label="资源标题"
                    align="center"
                  ></el-table-column>
                  <el-table-column
                    prop="subjectInfo.name"
                    min-width="80"
                    label="分支"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="status"
                    show-overflow-tooltip
                    label="状态"
                    min-width="70px"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span effect="dark" v-if="scope.row.status == 20"
                        >已上架</span
                      >
                      <span effect="dark" v-if="scope.row.status == 10"
                        >未上架</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="sourceInfo.name"
                    show-overflow-tooltip
                    label="来源"
                    min-width="70px"
                    align="center"
                  >
                  </el-table-column
                  >
          </el-table>
          <!-- 列表分页 -->
          <div class="pagination-box">
              <el-pagination
              @size-change="allItemHandleSizeChange"
              @current-change="allItemHandleCurrentChange"
              :current-page="allItemCurrentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="allItemPageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="allItemTotalSize"
              >
              </el-pagination>
          </div>
        </div>
         
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="addItemtoAd()">确 定</el-button>
            <el-button @click="addItemToAdDialog = false">取 消</el-button>
        </span>
       </el-dialog>
       <!-- 给广告编辑条目弹窗 -->
        <el-dialog
        title="编辑条目"
        :visible.sync="editItemDialog"
        width="800px"
       >
       <p style="margin-bottom: 20px;">
            <span>结束时间：</span>
            <el-date-picker
                v-model="editItemFrom.endTime"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
            >
            </el-date-picker>
        </p>
        <p style="margin-bottom: 20px;">
            <span>展示位置：</span>
            <el-select v-model="editItemFrom.type" clearable>
                <el-option value="10" label="顶部"> </el-option>
                <el-option value="20" label="侧边"> </el-option
                ><el-option value="30" label="底部"> </el-option>
            </el-select>
        </p>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="editItemtoAd()">确 定</el-button>
            <el-button @click="editItemDialog = false">取 消</el-button>
        </span>
       </el-dialog>

      <!-- 删除条目确认弹窗 -->
      <el-dialog
        title="删除广告"
        :visible.sync="deleteItemPreDialog"
        width="600px"
        >
        <div>确定给广告删除该条目</div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="deleteItemEntry">确 定</el-button>
            <el-button @click="deleteItemPreDialog = false">取 消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Menu from "../../menu/menu.vue";
import LeftSideBar from "../../menu/leftSideBar.vue";
import $ from "jquery";
import cookies from "vue-cookies";
export default {
  components: {
    Menu,
    LeftSideBar,
  },
  data() {
    return {
      newType: "",
      // 数据部分
      listTableData: [],
      multipleSelectionTable: [],
      allItemMultipleSelectionTable:[],
      itemMultipleSelectionTable:[],
      editItemFrom:{},
      props: {
        label: "name",
        children: "children",
        isLeaf: "leaf",
      },
      uploadType:"",
      dataList: [],
      listData: [],
      deleteIds: [],
      addTagIds:[],
      adverItemListData:[],
      addAdverTagForm:{},
      editAdverTagForm:{},
      runtimeKey: "",
      logoImgUrl: "",
      BUType: "",
      BUSubject: "",
      BUSubjectId: "",
      logInterval: null,
      selectedValue: null,
      successTitle: "",
      downloadTemplate: "",
      successContent: "",
      runTimeTitle: "",
      checkLogTitle: "",
      logChechContent: "",
      uploadAccept: "",
      startTime: "",
      acceptType: "",
      headers: {
        AuthorizationToken: cookies.get("token"),
      },
      upLodeData: {
        type: "",
      },
      addForm: {},
      editForm: {},
      createFlag: "add",
      newAdverTagTitle:"新增广告标签",
      deleteAdverTagId:"",
      allItemData:[],
      itemSearchForm:{},
      // 文件上传部分
      fileType: "", // 文件类型
      fileList: [], //上传文件列表

      sourceList: [],
      // 主列表分页
      currentPage: 1,
      pageSize: 10,
      totalSize: 50,
      // 所有条目列表分页
      allItemPageSize:10,
      allItemTotalSize:50,
      allItemCurrentPage:1,
      // 条目维护列表分页
      itemPageSize:10,
      itemTotalSize:50,
      itemCurrentPage:1,

      sourceContent: "",
      dataText: "",
      activeName: "first",
      optionData: [],
      adverTagList: [],
      mainTainItemId:"",
      maintainItemFrom:{},
      searchFileForm: {},
      allItemSearchForm:{},
      // 弹窗部分
      createDialog: false,
      editDialog:false,
      transDialog: false,
      logMMesDialog: false,
      successDialog: false,
      checkLogDialog: false,
      uploadPreDialog: false,
      createUpdateDialog: false,
      downloadTemplateDialog: false,
      deletePreDialog: false,
      adverTagManageDialog: false,
      addAdverTagDialog:false,
      deleteTagPreDialog:false,
      maintainItemDialog:false,
      addItemToAdDialog:false,
      deleteItemPreDialog:false,
      editItemDialog:false,
      addRules: {
        name: [{ required: true, message: "请输入标题", trigger: "blur" }],
        endTime: [{ required: true, message: "请输入结束时间", trigger: "blur" }],
      },
      editRules: {
        name: [{ required: true, message: "请输入标题", trigger: "blur" }],
        endTime: [{ required: true, message: "请输入结束时间", trigger: "blur" }],
      },
      addAdverTagRules:{
         name: [{ required: true, message: "请输入标签名称", trigger: "blur" }],
      },
      editAdverTagRules:{
         name: [{ required: true, message: "请输入标签名称", trigger: "blur" }],
      }
    };
  },
  mounted() {
    // 统一验证token
    var currentToken = cookies.get("token");
    $.ajaxSetup({
      headers: {
        AuthorizationToken: currentToken,
      },
      complete: function (xhr) {
        if (xhr.responseJSON.code == 401) {
          window.location.href = "/";
        }
      },
    });
    this.searchParam();
  },
  methods: {
    onSearch() {
      this.searchParam();
    },
    allItemOnSearch() {
      this.getAllItem();
    },
    itemOnSearch() {
      this.gatCurrentItem();
    },
    // 加载数据
    searchParam() {
      let that = this;
      let params = Object.assign({}, this.searchFileForm);
      params.size = this.pageSize;
      params.page = this.currentPage;
      $.ajax({
        type: "GET",
        dataType: "json",
        url: "/zyk/c/adver/adverInfo/list",
        data: params,
        contentType: "application/json;charset=utf-8",
        success: function (response) {
          if (response.code == 200) {
            that.optionData = response.obj.list;
            if (response.obj && response.obj.length == 0) {
              that.dataText = "暂无数据";
            }
            that.totalSize = response.obj.total;
            that.listTableData = response.obj.list;
            that.currentPage = response.obj.pageNum; 
            that.listTableData.forEach((item) => {
              item.tagNames = item.tagInfos.map((tagItem) => {return tagItem.name}).join("，");
            });

          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    // 树形结构加载
    loadNode(node, resolve) {
      let that = this;
      this.getAuthority = node;
      $.ajax({
        url: "/zyk/subject/resourceSubject?size=1000&page=1",
        type: "GET",
        //contentType: 'application/json;charset=utf-8',
        dataType: "json",
        data: { flag: 10 },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          if (node.level == 0) {
            return resolve([{ name: "百科数据资源库", id: "-1" }]);
          } else if (node.level == 1) {
            this.treeNode_had = node;
            that.dataList = data.obj.list;
            return resolve(that.dataList);
          } else {
            $.ajax({
              url: "/zyk/c/subject/subjectInfo/list?size=1000&page=1",
              type: "GET",
              //contentType: 'application/json;charset=utf-8',
              data: { id: node.data.id },
              dataType: "json",
              error: function (xhr) {
                if (xhr.status == 401) {
                  window.location.reload();
                }
              },
              success: function (data) {
                return resolve(data.obj.list);
              },
            });
          }
        },
      });
    },
    // 删除、上下架前确认
    preCheck(current) {
      let that = this;
      let ids = this.multipleSelectionTable.map((item) => {
        return item.id;
      });
      let flagArr = [];
      let flag = true;
      let statusArr = this.multipleSelectionTable.map((item) => {
        return item.status;
      });
      if (this.multipleSelectionTable.length == 0) {
        this.$message({
            message: "请选中具体的资源",
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
      } else if (current == "toDown") {
        $.ajax({
            type: "POST",
            dataType: "json",
            data: {
              ids: ids.toString(),
              status: 10,
            },
            url: "/zyk/c/adver/adverInfo/onoff",
            success: function (response) {
              if (response.code == 200) {
                that.searchParam();
                that.$message({
                  message: response.msg,
                  duration: 0,
                  showClose: true,
                  type: "success",
                  offset: 100,
                });
              } else {
                that.$message({
                  message: response.msg,
                  duration: 0,
                  showClose: true,
                  type: "error",
                  offset: 100,
                });
              }
            },
            error: function (data) {
              console.log(data);
            },
          });
      } else if (current == "toUP") {
        $.ajax({
            type: "POST",
            dataType: "json",
            data: {
              ids: ids.toString(),
              status: 20,
            },
            url: "/zyk/c/adver/adverInfo/onoff",
            success: function (response) {
              if (response.code == 200) {
                that.searchParam();
              } else {
                that.$message({
                  message: response.msg,
                  duration: 0,
                  showClose: true,
                  type: "error",
                  offset: 100,
                });
              }
            },
            error: function (data) {
              console.log(data);
            },
          });
      } else if (current == "toDelete") {
        $.each(statusArr, function (index, element) {
          if (element === 10) {
            flagArr.push(true);
          } else {
            flagArr.push(false);
          }
        });
        flag = flagArr.every(function (value) {
          return value;
        });
        if (!flag) {
          that.$message({
            message: "广告启用状态，请停用后再删除",
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        } else {
          this.deletePreDialog = true;
        }
      }
    },
    // 时间戳转换
    timestampToDate(timestamp) {
      var date = new Date(timestamp); // 将时间戳转换为Date对象
      return date.toISOString().slice(0, 10); // 将Date对象转换为YYYY-MM-DD格式
    },
    handleCheckChange() {
      let that = this;
      let res = this.$refs.tree.getCurrentNode();
      this.selectedValue = res.name;
      this.BUSubject = res.name;
      that.BUSubjectId = res.id;
      this.addForm.subjectId = res.id;
    },
    // 类型选择改变时，文件类型也改变
    addTypeChange(value) {
      let that = this;
      if (value == 1) {
        that.acceptType = ".jpg,.png,.gif";
      } else if (value == 2) {
        that.acceptType = ".mp4";
      } else if (value == 3) {
        that.acceptType = ".mp3";
      }
    },
    // 显示上传资源包弹框
    firstCreate() {
      // let that = this;
      this.addForm = {};
      this.logoImgUrl = "";
      this.selectedValue = "";
      this.fileList=[];
      this.addTagIds = [];
      this.getAdverTagList();
      this.createDialog = true;
    },
    // 编辑广告内容
    editAdver(row) {
      // let that = this;
      this.editForm = {
        id:row.id,
        name:row.name,
        link:row.link,
        linkContent:row.linkContent,
        logo:row.logo,
        path:row.path,
        endTime:row.endTime,
      };
      this.addTagIds = row.tagInfos.map((item) => {
        return item.id;
      });
      this.fileList = [
        {
          name: row.name,
          url: row.path,
        },
      ];
      this.logoImgUrl = row.logo;
      this.getAdverTagList();
      this.editDialog = true;
    },
    // 获取实时日志
    getRuntimeLog(runtimeKey) {
      let that = this;
      this.logInterval = setInterval(function () {
        $.ajax({
          type: "GET",
          dataType: "json",
          data: { runtimeKey: runtimeKey, timeCurrent: $.now() },
          url: "/zyk/storage/runtimeLog",
          success: function (response) {
            if (response.code == 200) {
              if (response.obj == null) {
                $(".logContent").text("正在操作...");
              } else {
                $(".logContent").text(response.obj);
              }
              if (response.obj.indexOf("转换完成") !== -1) {
                clearInterval(that.logInterval);
                this.successDialog = true;
                this.transDialog = false;
                this.successTitle = "资源包转换结果";
                this.successContent = "转换成功！";
              } else if (response.obj.indexOf("导入完成") !== -1) {
                clearInterval(that.logInterval);
                that.successDialog = true;
                that.transDialog = false;
                that.successTitle = "资源包导入结果";
                that.successContent = "导入成功！";
              } else {
                // console.log("正在操作");
                console.log(response.obj);
              }
            } else {
              that.$message({
                message: response.msg,
                duration: 0,
                showClose: true,
                type: "error",
                offset: 100,
              });
            }
          },
          error: function (data) {
            console.log(data);
          },
        });
      }, 1000);
      this.transDialog = true;
    },
    // 成功弹窗事件
    successClick() {
      let that = this;
      this.successDialog = false;
      that.searchParam();
    },
    // 选择来源时table刷新
    tableRefresh() {
      let that = this;
      let currentSource = this.sourceContent;
      console.log(currentSource);
      that.searchParam();
    },
    uploadPre() {
      this.uploadPreDialog = true;
    },
    checkLog() {
      this.checkLogDialog = true;
    },
    // 选择表格某一行
    handleTableSelectionChange(val) {
      this.multipleSelectionTable = val;
    },
    adverItemHandleTableSelectionChange(val) {
      this.itemMultipleSelectionTable = val;
    },
    allItemHandleTableSelectionChange(val) {
      this.allItemMultipleSelectionTable = val;
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.searchParam();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.searchParam();
    },
    // 分页
    allItemHandleSizeChange(val) {
      this.allItemPageSize = val;
      this.getAllItem();
    },
    allItemHandleCurrentChange(val) {
      this.allItemCurrentPage = val;
      this.getAllItem();
    },// 分页
    itemHandleSizeChange(val) {
      this.itemPageSize = val;
      this.gatCurrentItem();
    },
    itemHandleCurrentChange(val) {
      this.itemCurrentPage = val;
      this.gatCurrentItem();
    },
    
    ytSubmitUpload() {
      this.$refs.ytupload.submit();
    },
    submitbatchUpload() {
      this.$refs.batchUpload.submit();
    },

    // 上传文件之前的钩子，对文件大小进行校验
    beforeUpload(file) {
    var that = this
      const isLt2M = file.size / 1024 / 1024 / 1024 < 4;
      if (!isLt2M) {
        this.$message.error("资源超过上传上限4G，如仍需上传，请联系管理员。");
        return isLt2M;
      }
      const fileName = file.name.toLowerCase();
      const fileType = file.type;
    
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'];
      const videoExtensions = ['.mp4', '.avi', '.mov', '.wmv', '.flv', '.mkv', '.webm'];
    
      const isImageByExt = imageExtensions.some(ext => fileName.endsWith(ext));
      const isVideoByExt = videoExtensions.some(ext => fileName.endsWith(ext));
      const isImageByType = fileType.startsWith('image/');
      const isVideoByType = fileType.startsWith('video/');
    // 双重验证，更准确
      if ((isImageByExt && isImageByType) || (!isVideoByExt && isImageByType)) {
        that.uploadType = '1' //图片类型
      } else if ((isVideoByExt && isVideoByType) || (!isImageByExt && isVideoByType)) {
        that.uploadType = '2' //视频类型
      }  
      this.$refs.zyupload.data.type = this.uploadType;
    },
    // 文件上传
    zySubmitUpload() {
      this.$refs.zyupload.submit();
    },
    beforeBatchUploadData(file) {
      const isLt2M = file.size / 1024 / 1024 / 1024 < 4;
      if (!isLt2M) {
        this.$message.error("资源超过上传上限4G，如仍需上传，请联系管理员。");
        return isLt2M;
      }
    },
    // 上传成功的钩子
    zySuccess(response) {
      let that = this;
      console.log(response);
      that.addForm.path = response.obj;
    },
    yuSuccess(response) {
      console.log(response);
      let that = this;
      that.addForm.resourcePath = response.obj;
    },
    BUSuccess(response) {
      let that = this;
      if (response.code == 200) {
        that.$message({
          message: "资源上传成功",
          duration: 2000,
          showClose: true,
          type: "success",
          offset: 100,
        });
        that.searchParam();
        that.createUpdateDialog = false;
      } else {
        that.$message({
          message: response.msg,
          duration: 2000,
          showClose: true,
          type: "error",
          offset: 100,
        });
      }
    },
    BUError(response) {
      let that = this;
      that.$message({
        message: response.msg,
        duration: 2000,
        showClose: true,
        type: "error",
        offset: 100,
      });
    },
    // 新增提交
    onCreate(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addForm.tagIds = this.addTagIds.toString();
          let that = this;
          $.ajax({
            url: "/zyk/c/adver/adverInfo/add",
            type: "POST",
            //contentType: 'application/json;charset=utf-8',
            dataType: "json",
            data: this.addForm,
            error: function (xhr) {
              if (xhr.status == 401) {
                window.location.reload();
              }
            },
            success: function (data) {
              if (data.code == 200) {
                that.$message({
                  message: "广告添加成功",
                  duration: 2000,
                  showClose: true,
                  type: "success",
                  offset: 100,
                });
                that.searchParam();
                that.createDialog = false;
              } else {
                that.$message({
                  message: data.msg,
                  duration: 0,
                  showClose: true,
                  type: "error",
                  offset: 100,
                });
              }
            },
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 新增提交
    onEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editForm.tagIds = this.addTagIds.toString();
          let that = this;
          $.ajax({
            url: "/zyk/c/adver/adverInfo/update",
            type: "POST",
            //contentType: 'application/json;charset=utf-8',
            dataType: "json",
            data: this.editForm,
            error: function (xhr) {
              if (xhr.status == 401) {
                window.location.reload();
              }
            },
            success: function (data) {
              if (data.code == 200) {
                that.$message({
                  message: "广告修改成功",
                  duration: 2000,
                  showClose: true,
                  type: "success",
                  offset: 100,
                });
                that.searchParam();
                that.editDialog = false;
              } else {
                that.$message({
                  message: data.msg,
                  duration: 0,
                  showClose: true,
                  type: "error",
                  offset: 100,
                });
              }
            },
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    downloadImportTemplate() {
      this.downloadTemplateDialog = true;
    },
    templateDownload() {
      let that = this;
      var downloadA = document.createElement("a");
      console.log("token:"+cookies.get("token"));
      
      $.ajax({
        type: "GET",
        dataType: "json",
        url: "/zyk/adver/downloadTemplate",
        headers: {
            AuthorizationToken: cookies.get("token"),
        },
        // contentType: "text/xml",
        success: function (response) {
          if (response.code == 200) {
            downloadA.href = response.obj.url;
            downloadA.download;
            downloadA.click();
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    batchUpload() {
      let that = this;
      that.BUType = "";
      that.BUSubjectId = "";
      that.BUSubject = "";
      that.fileList = [];
      this.createUpdateDialog = true;
    },
    // 缩略图上传成功钩子
    handleAvatarSuccess(response) {
      let that = this;
      that.logoImgUrl = response.obj;
      that.addForm.logo = response.obj;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type == "image/jpeg";
      const isPNG = file.type == "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG && !isPNG) {
        this.$message.error("上传缩略图只能是 JPG或PNG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传缩略图大小不能超过 2MB!");
      } else {
        this.$refs.logoUpload.data.type = '1';
      }
    },
    // 删除广告条目
    deleteEntry() {
      let that = this;
      that.deleteIds = this.multipleSelectionTable.map((item) => {
        return item.id;
      });

      $.ajax({
        url: "/zyk/c/adver/adverInfo/remove",
        type: "POST",
        //contentType: 'application/json;charset=utf-8',
        dataType: "json",
        data: { ids: this.deleteIds.toString() },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          if (data.code == 200) {
            that.$message({
              message: "删除成功",
              duration: 2000,
              showClose: true,
              type: "success",
              offset: 100,
            });
            that.deletePreDialog = false;
            that.searchParam();
          } else {
            that.$message({
              message: data.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
      });
    },
    // 删除广告绑定条目
    deleteItemEntry() {
      let that = this;
      var param={
        wordIds:this.itemMultipleSelectionTable.map((item) => {return item.wordId}).toString(),
        adverId:this.mainTainItemId
      }
      $.ajax({
        url: "/zyk/adver/removeItem",
        type: "POST",
        //contentType: 'application/json;charset=utf-8',
        dataType: "json",
        data: param,
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          if (data.code == 200) {
            that.$message({
              message: "删除成功",
              duration: 2000,
              showClose: true,
              type: "success",
              offset: 100,
            });
            that.deleteItemPreDialog = false;
            that.gatCurrentItem();
          } else {
            that.$message({
              message: data.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
      });
    },
    // 获取广告标签列表
    getAdverTagList(){
        var that = this;
        $.ajax({
            type: "POST",
            dataType: "json",
            url: "/zyk/c/adver/adverTag/list",
            success: function (response) {
              if (response.code == 200) {
                that.adverTagList = response.obj.list;
              } else {
                that.$message({
                  message: response.msg,
                  duration: 0,
                  showClose: true,
                  type: "error",
                  offset: 100,
                });
              }
            },
            error: function (data) {
              console.log(data);
            },
          });
    },
    // 新建广告标签
    createAdverTag(){
        var flag = this.createFlag
        var that = this;
        switch (flag) {
            case "add":
                $.ajax({
                type: "POST",
                dataType: "json",
                url: "/zyk/c/adver/adverTag/add",
                data: this.addAdverTagForm,
                success: function (response) {
                if (response.code == 200) {
                    that.addAdverTagDialog = false;
                    that.getAdverTagList();
                    that.$message({
                        message: response.msg,
                        duration: 0,
                        showClose: true,
                        type: "success",
                        offset: 100,
                    });
                } else {
                    that.$message({
                        message: response.msg,
                        duration: 0,
                        showClose: true,
                        type: "error",
                        offset: 100,
                    });
                }
                },
                error: function (data) {
                    console.log(data);
                },
                });
                break;
            case "edit":
                $.ajax({
                type: "POST",
                dataType: "json",
                url: "/zyk/c/adver/adverTag/update",
                data: this.editAdverTagForm,
                success: function (response) {
                if (response.code == 200) {
                    that.addAdverTagDialog = false;
                    that.getAdverTagList();
                    that.$message({
                        message: response.msg,
                        duration: 0,
                        showClose: true,
                        type: "success",
                        offset: 100,
                    });
                } else {
                    that.$message({
                        message: response.msg,
                        duration: 0,
                        showClose: true,
                        type: "error",
                        offset: 100,
                    });
                }
                },
                error: function (data) {
                    console.log(data);
                },
                });
                break;
        
            default:
                break;
        }
    },
    // 编辑广告标签
    editAdverTag(row) {
        console.log(row);
        this.newAdverTagTitle = "编辑广告标签";
        this.createFlag = "edit";
        this.editAdverTagForm={
            id:row.id,
            name:row.name,
            remark:row.remark,
        }
        this.addAdverTagDialog = true;
    },
    // 删除广告标签
    deleteTagEntry(){
        var that = this;
        $.ajax({
        type: "POST",
        dataType: "json",
        url: "/zyk/c/adver/adverTag/remove",
        data: {ids:this.deleteAdverTagId},
        success: function (response) {
        if (response.code == 200) {
            that.deleteTagPreDialog = false;
            that.getAdverTagList();
            that.$message({
                message: response.msg,
                duration: 0,
                showClose: true,
                type: "success",
                offset: 100,
            });
        } else {
            that.$message({
                message: response.msg,
                duration: 0,
                showClose: true,
                type: "error",
                offset: 100,
            });
        }
        },
        error: function (data) {
            console.log(data);
        },
        });
    },
    // 打开维护条目
    toMaintainItem(currentId){
        this.itemSearchForm = {};
        this.mainTainItemId = currentId;
        this.gatCurrentItem();
        this.maintainItemDialog = true;
    },
    gatCurrentItem(){
      var that = this;
      let params = Object.assign({}, this.itemSearchForm);
      params.adverId = this.mainTainItemId;
      params.size = this.itemPageSize;
      params.page = this.itemCurrentPage;   
        $.ajax({
            type: "GET",
            dataType: "json",
            url: "/zyk/adver/itemList",
            data: params,
            success: function (response) {
            if (response.code == 200) {
                that.adverItemListData = response.obj.list;
                that.itemTotalSize = response.obj.total;
                that.itemCurrentPage = response.obj.pageNum; 
            } else {
                that.$message({
                    message: response.msg,
                    duration: 0,
                    showClose: true,
                    type: "error",
                    offset: 100,
                });
            }
            },
            error: function (data) {
                console.log(data);
            },
        });
    },
        // 加载数据
    getAllItem() {
      let that = this;
      let params = Object.assign({}, this.allItemSearchForm);
      params.type = 10;
      params.size = this.allItemPageSize;
      params.page = this.allItemCurrentPage;
      $.ajax({
        type: "GET",
        dataType: "json",
        url: "/zyk/c/subject/wordInfo/list",
        data: params,
        // contentType: "application/json;charset=utf-8",
        success: function (response) {
          if (response.code == 200) {
            that.optionData = response.obj.list;
            if (response.obj.list && response.obj.list.length == 0) {
              that.dataText = "暂无数据";
            }
            that.allItemTotalSize = response.obj.total;
            that.allItemData = response.obj.list;
            that.allItemCurrentPage = response.obj.pageNum;
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    addItemtoAd(){
        var that = this;
        this.maintainItemFrom.adverId = this.mainTainItemId;
        this.maintainItemFrom.wordIds = this.allItemMultipleSelectionTable.map(item=>{return item.id}).toString();
        $.ajax({
            type: "POST",
            dataType: "json",
            url: "/zyk/adver/addItem",
            data: this.maintainItemFrom,
            // contentType: "application/json;charset=utf-8",
            success: function (response) {
            if (response.code == 200) {
                that.gatCurrentItem()
                that.addItemToAdDialog = false; 
                that.$message({
                message: "新增完成",
                duration: 0,
                showClose: true,
                type: "success",
                offset: 100,
                });
            } else {
                that.$message({
                message: response.msg,
                duration: 0,
                showClose: true,
                type: "error",
                offset: 100,
                });
            }
            },
            error: function (data) {
            console.log(data);
            },
        });       
    },
    editItemtoAd(){
        var that = this;
        $.ajax({
            type: "POST",
            dataType: "json",
            url: "/zyk/adver/modifyItem",
            data: this.editItemFrom,
            // contentType: "application/json;charset=utf-8",
            success: function (response) {
            if (response.code == 200) {
                that.gatCurrentItem()
                that.editItemDialog = false; 
                that.$message({
                message: "修改完成",
                duration: 0,
                showClose: true,
                type: "success",
                offset: 100,
                });
            } else {
                that.$message({
                message: response.msg,
                duration: 0,
                showClose: true,
                type: "error",
                offset: 100,
                });
            }
            },
            error: function (data) {
            console.log(data);
            },
        });       
    },
    commitMaintainItem(){
      var that = this;
        this.maintainItemFrom.wordIds = this.adverItemListData.map(item=>{return item.id}).toString();
        $.ajax({
            type: "POST",
            dataType: "json",
            url: "/zyk/adver/addItem",
            data: this.maintainItemFrom,
            // contentType: "application/json;charset=utf-8",
            success: function (response) {
            if (response.code == 200) {
                this.maintainItemDialog = false;        
                that.$message({
                message: "操作完成",
                duration: 0,
                showClose: true,
                type: "success",
                offset: 100,
                });
            } else {
                that.$message({
                message: response.msg,
                duration: 0,
                showClose: true,
                type: "error",
                offset: 100,
                });
            }
            },
            error: function (data) {
            console.log(data);
            },
        });
    },
    editPre(){
      console.log(this.itemMultipleSelectionTable.length);
      var itemLength = this.itemMultipleSelectionTable.length;
      if(itemLength == 0){
        this.$message({
            message: "请选择要操作的条目",
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
        });
      }else if(itemLength > 1){
        this.$message({
            message: "请选择单个条目进行操作",
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
        });
      }else{
        this.editItemDialog = true;
        this.editItemFrom = {
          id: this.itemMultipleSelectionTable[0].id,
          endTime: this.itemMultipleSelectionTable[0].endTime,
          type: this.itemMultipleSelectionTable[0].type.toString()
        }
      }
      
    },
    // 获取来源list
    getSourceList() {
      let that = this;
      $.ajax({
        type: "GET",
        dataType: "json",
        data: {
          page: 1,
          size: 1000,
        },
        url: "/zyk/c/source/sourceInfo/list",
        success: function (response) {
          if (response.code == 200) {
            that.optionData = response.obj.list;
            if (response.obj && response.obj.list.length == 0) {
              that.dataText = "暂无数据";
            }
            that.sourceList = response.obj.list;
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    }
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.uploadBox .avatar-uploader .el-upload .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}
.avatar {
  width: 150px;
  height: 150px;
  display: block;
}

.adverTagItem button{
    margin: 0 10px 10px;
}

#addItemToAdSearchBox .el-form-item, #itemSearchBox .el-form-item{
  float: left;
  width: auto;
}
</style>